module.exports = __webpack_public_path__ + "assets/img/40.8e9c73f3.png";